import _regeneratorRuntime from "F:/Mo/wb/\u51CF\u91CD\u5C0F\u7A0B\u5E8F/diss-fat-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "F:/Mo/wb/\u51CF\u91CD\u5C0F\u7A0B\u5E8F/diss-fat-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import request from "@/utils/request";
import ajaxUrl from "@/api/index";
import appConfig from "@/app.config";
import { Toast } from "vant";
export default {
  data: function data() {
    return {
      params: {
        name: "moxiaxian"
      }
    };
  },
  components: {},
  watch: {},
  mounted: function mounted() {},
  methods: {
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$request, data, status;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.showLoading();
              _context.next = 3;
              return request({
                method: "post",
                url: ajaxUrl.getRegisterPatientInfo,
                data: {
                  appId: appConfig.wxAppId
                }
              });
            case 3:
              _yield$request = _context.sent;
              data = _yield$request.data;
              status = _yield$request.status;
              if (!(status !== 0)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              _this.hideLoading();
              console.log(data);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};